import React, { useState, useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import "./App.scss";
import { Redirect, useLocation, useHistory } from "react-router-dom";
import Home from "./pages/Home";
import PaymentStatus from "./pages/PaymentStatus";
import { EStatusTrip } from "./helpers/const";
import $axios from "./services/axios";
import Tracking from "./pages/Tracking";
import { message } from "antd";
import dayjs from "dayjs";

const App = () => {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(window.location.search);
  const verifyTokenRaw =
  queryParams.get("VerifyToken") || queryParams.get("verifyToken");
  let verifyToken = verifyTokenRaw?.replace(/ /g, "+");
  const prevLink = queryParams.get("prevLink") || "";
  const decodeToken = async () => {
    // Lấy token từ URL
    if (
      verifyToken
    ) {
      try {
          localStorage.removeItem("taxiIpassToken");
          verifyToken = verifyToken?.replace(/ /g, "+");
          const res = await $axios.$post("/api/v1/gsm/login", {
            VerifyToken: verifyToken,
          });
          const token = res.data.data.token;
          localStorage.setItem("taxiIpassToken", token);
          const userInfo = res.data.data.userInfo;
          userInfo.phone = userInfo.phone.replace(/^84/, "0");
          sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
          if (location.pathname === "/taxi" && token) {
            setTimeout(() => {
              fetchBookingInfo();
            }, prevLink === "tracking" ? 3000 : 1000);
          }
      } catch (error) {
        console.log(error,'error');
        message.error(error?.message || "Xảy ra lỗi vui lòng thử lại !");
      }
    }
    else {
      const stored = localStorage.getItem("taxiIpassToken");
      if (stored) {
        try {
          const payloadBase64 = stored.split(".")[1];
          if (payloadBase64) {
            const payload = JSON.parse(
              atob(payloadBase64.replace(/-/g, "+").replace(/_/g, "/")),
            );
            if (payload.exp && payload.exp * 1000 < Date.now()) {
              localStorage.removeItem("taxiIpassToken");
              message.error("Xảy ra lỗi token hết hạn vui lòng thử lại !");
            }
            if (location.pathname === "/taxi") {
              setTimeout(() => {
                fetchBookingInfo();
              }, prevLink === "tracking" ? 3000 : 1000);
            }
          }
        } catch (e) {
          localStorage.removeItem("taxiIpassToken");
          return null;
        }
      }
    }
  };

  useEffect(() => {
    decodeToken();
  }, []);

  const fetchBookingInfo = async () => {
    removePrevLinkParam();
    const end = dayjs();
    const start = end.subtract(6, "day");
    const startTime = start.format("DD/MM/YYYY") + " 00:00:00";
    const endTime = end.format("DD/MM/YYYY") + " 00:00:00";
    try {
      const res = await $axios.$get(
        `/api/v1/gsm/transactions/list?startDate=${startTime}&endDate=${endTime}&page=${1}&pageSize=10`
      );
      const histories = res.data.data.data;
      if (histories.length > 0) {
        const tripId = histories[0].tripId;
        const tripStatus = histories[0].tripStatus;
        if ([
          EStatusTrip.CCANCELLED,
          EStatusTrip.MISSED,
        ].includes(tripStatus)) {
          return;
        }
        const resTrip = await $axios.get(
          `/api/v1/gsm/trip/tracking?tripId=${tripId}`
        );
        if (resTrip?.data?.data) {
          if (
            [
              EStatusTrip.ARRIVED,
              EStatusTrip.COMING,
              EStatusTrip.FINDING,
              EStatusTrip.JOURNEY,
            ].includes(resTrip?.data?.data.status)
          ) {
            message.success("Bạn có chuyến đi chưa hoàn thành!");
            history.push(`/tracking?orderCode=${histories[0].orderCode}`);
          }
          else if ([
            EStatusTrip.MISSED,
          ].includes(resTrip?.data?.data.status)) {
            message.warning("Không tìm thấy chuyến đi phù hợp!");
          }
        }
      }
    } catch (error) {
      console.log(error,'error');
      // message.error(error?.response?.data?.message || "Xảy ra lỗi tracking chuyến đi vui lòng thử lại !");
    } finally {
    }
  };

  const removePrevLinkParam = () => {
    const params = new URLSearchParams(location.search);
    params.delete("prevLink");
  
    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });
  };


  return (
    <>
      <Switch>
        <Redirect exact from="/" to={"/taxi"} />
        <Route exact path={"/taxi"} render={(props) => <Home {...props} />} />
        <Route
          exact
          path={"/payment-status"}
          render={(props) => <PaymentStatus {...props} />}
        />
        <Route
          exact
          path={"/tracking"}
          render={(props) => <Tracking {...props} />}
        />
        <Redirect to={"/taxi"} />
      </Switch>
    </>
  );
};
export default App;
